import { useEffect, useState } from "react";
import axios from "axios";
import { useLang } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEYS = ["marquee.1", "marquee.2", "marquee.3", "marquee.4", "marquee.5", "marquee.6", "marquee.7", "marquee.8"];

export default function Marquee() {
  const { t } = useLang();
  const [clubs, setClubs] = useState([]);

  useEffect(() => {
    axios.get(`${API}/logos`).then((r) => setClubs(r.data.filter((l) => l.categorie === "club"))).catch(() => {});
  }, []);

  // Bande défilante des logos des clubs recruteurs (gérés dans Réglages) — sinon texte par défaut
  if (clubs.length > 0) {
    const row = [...clubs, ...clubs];
    return (
      <div data-testid="editorial-marquee" className="border-y border-[#27272A] bg-[#0A0A0C] py-8 overflow-hidden">
        <div className="animate-marquee flex w-max items-center">
          {row.map((club, i) => (
            <span key={`${club.id}-${i}`} data-testid={i < clubs.length ? `marquee-club-${club.id.slice(0, 8)}` : undefined} className="flex items-center px-10">
              <img src={club.image} alt={club.nom} title={club.nom} className="h-14 md:h-16 w-auto object-contain grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-300" />
            </span>
          ))}
        </div>
      </div>
    );
  }

  const items = KEYS.map((k) => t(k));
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="border-y border-[#27272A] bg-[#0A0A0C] py-6 overflow-hidden">
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display uppercase text-2xl md:text-3xl tracking-wider text-[#71717A] px-8">
              {item}
            </span>
            <span className="text-[#C5A059] text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
